export class ConsentOutDTO {
  hasConsent!: boolean;
  obtainConsentUrl?: string;
}
